module.exports = __webpack_public_path__ + "img/victoria-Falls.d59c1ad5.jpg";